import { useRef } from 'react'
import { createFoodSafetySaveLock } from 'src/utils/foodSafetySaveGuard'

/** One synchronous save lock per mounted screen / hook (38.12). */
export default function useFoodSafetySaveLock() {
  const ref = useRef(null)
  if (!ref.current) ref.current = createFoodSafetySaveLock()
  return ref.current
}
